import { useState, useEffect, useContext } from 'react';
import { MdArrowBack } from 'react-icons/md';
import { AppContext } from '../App';
import logo_wide from '../assets/logo_wide.png';

export default function TopBar (props) {

  const appContext = useContext(AppContext);
  const [ title, setTitle ] = useState(props.title);

  useEffect(() => {
    setTitle(props.title);
  }, [ props.title ])
  return (
    <div className="TopBar">
      <div className="d-flex justify-content-between container" style={{ height: "100%" }}>
        <p className="mNoMargin align-self-center font-light" style={{ fontSize: "20px", width: "250px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", textTransform: "uppercase" }}>
          <MdArrowBack onClick={appContext.navBack} size={30} style={{ cursor: "pointer" }} color="var(--goldish)"/>&nbsp;
          {title}
        </p>
        <div className="mNoMargin align-self-center" style={{ height: "70%", flexShrink: "0", cursor: "pointer" }}>
          <img onClick={() => appContext.navTo({ item: 'dashboard' }) }  src={logo_wide} style={{ height: "100%", width: "auto", cursor: "pointer" }}/>
          
        </div>
      </div>
    </div>
  )
}
